import type { SVGProps } from 'react';

type SVGRProps = {
  title?: string;
  titleId?: string;
};

export const Users = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 12 12"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6 2.625C6 3.66053 5.16053 4.5 4.125 4.5C3.08947 4.5 2.25 3.66053 2.25 2.625C2.25 1.58947 3.08947 0.75 4.125 0.75C5.16053 0.75 6 1.58947 6 2.625Z"
      fill="currentColor"
    />
    <path
      d="M2.25 6C1.00736 6 0 7.00736 0 8.25V10.5H6V6H2.25Z"
      fill="currentColor"
    />
    <path
      d="M9.75 6H7.5V10.5H12V8.25C12 7.00736 10.9926 6 9.75 6Z"
      fill="currentColor"
    />
    <path
      d="M9 4.5C9.82843 4.5 10.5 3.82843 10.5 3C10.5 2.17157 9.82843 1.5 9 1.5C8.17157 1.5 7.5 2.17157 7.5 3C7.5 3.82843 8.17157 4.5 9 4.5Z"
      fill="currentColor"
    />
  </svg>
);
